import { render, staticRenderFns } from "./FileHistory.vue?vue&type=template&id=0325cc06&scoped=true&"
import script from "./FileHistory.vue?vue&type=script&lang=js&"
export * from "./FileHistory.vue?vue&type=script&lang=js&"
import style0 from "./FileHistory.vue?vue&type=style&index=0&id=0325cc06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0325cc06",
  null
  
)

export default component.exports